/**
 * M9 CH-12a: the hulk loop's Reach subsystem. The interaction arbiter collects providers once at init, before the
 * hulks feature binds its live loop (`features/hulks/feature.ts`), so this subsystem hands the arbiter a stable
 * provider that forwards to the bound loop (the story subsystem's pattern), and steps the loop's squat fight per
 * tick. Allocation-free while nothing is bound.
 */
import type { InteractableProvider, ReachSubsystem } from '../reach/runtime/types'
import type { HulkLive } from './live'

let bound: HulkLive | null = null

/** The bound live hulk loop, or null (CH-12e: the dev shortcuts hand it their spawned hulks). */
export function boundHulkLive(): HulkLive | null {
  return bound
}

/** Binds (or, with null, unbinds) the live hulk loop. */
export function bindHulkLive(live: HulkLive | null): void {
  bound = live
}

const prompts: InteractableProvider = {
  nearest: (core, sim, out) => bound?.prompts.nearest(core, sim, out) ?? false,
  activate: (core, sim, prompt) => bound?.prompts.activate(core, sim, prompt) ?? { ok: false, error: 'invalid', message: '' },
}

export default function createHulksSubsystem(): ReachSubsystem {
  return {
    name: 'hulks',
    // After the story subsystem (470): its derelict ports win a tie at equal distance.
    order: 472,
    interactables: [prompts],
    init(): void {},
    step(core, sim): void {
      bound?.step(core, sim)
    },
    onSystemLeave(core): void {
      bound?.leave(core)
    },
  }
}
